import React, { useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import './style.css';
import { Accordion, Col, Container, Row } from 'react-bootstrap';
import { IMAGE_CONSTANT } from '../../../../constants/app';
import { mobilityFoundationsFAQs } from '../../constant';
import { getDisplayType } from '../../../../utils/helpers';
import useWindowWidth from '../../../../hooks/useWindowWidth';

const CustomToggle = props => {
  return (
    <div className="accordion-toggler" onClick={props.onClick}>
      <p>{props.children}</p>
      <img
        src={
          props.expanded ? IMAGE_CONSTANT.chevronUp : IMAGE_CONSTANT.chevronDown
        }
        alt="toggle"
      />
    </div>
  );
};

const CustomFormatter = ({ data }) => {
  const { description } = data;
  const isDesktopScreen = getDisplayType(useWindowWidth()) === 'desktop';
  const [readMore] = useState(!isDesktopScreen);
  const filteredData = isDesktopScreen
    ? description
    : readMore
    ? description.slice(0, 1)
    : description;

  return filteredData.map((item, index, arr) => (
    <span key={`point-${index + 1}`}>{parse(item)}</span>
  ));
};
const accordionData = mobilityFoundationsFAQs.map(item => ({
  ...item,
  customFormatter: data => <CustomFormatter data={data} />,
}));

const FAQSection = props => {
  const [activeKey, setActiveKey] = React.useState('0');
  const handleSelect = key => {
    setActiveKey(key);
  };
  return (
    <div className="faq-section">
      <h2>
        Frequently <em>asked</em> questions
      </h2>
      <Container>
        <Row className="faq-row">
          <Col xl={12} className="d-flex align-items-center">
            <div className="left-div text-center w-100">
              <Accordion activeKey={activeKey} onSelect={handleSelect}>
                {accordionData.map((data, index) => (
                  <div
                    key={`accordion-${index + 1}`}
                    className={`accordion-wrapper ${
                      +activeKey === index ? 'active' : 'inactive'
                    }`}
                  >
                    <Accordion.Toggle
                      as={props => (
                        <CustomToggle
                          {...props}
                          expanded={activeKey === String(index)}
                        />
                      )}
                      eventKey={String(index)}
                    >
                      {data.title}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={String(index)}>
                      <div>
                        {data.customFormatter
                          ? data.customFormatter(data)
                          : data.description}
                      </div>
                    </Accordion.Collapse>
                  </div>
                ))}
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CustomToggle.propTypes = {
  children: PropTypes.node,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
};

FAQSection.propTypes = {};

CustomFormatter.propTypes = {
  data: PropTypes.object,
};

export default FAQSection;
